module.exports = __webpack_public_path__ + "img/badge_welfare_di_marca.ef71c3ff.jpg";